import { render } from "./PlaybookCategorySidebar.vue?vue&type=template&id=0e263768"
import script from "./PlaybookCategorySidebar.vue?vue&type=script&lang=js"
export * from "./PlaybookCategorySidebar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__